import WithdrawSuccessFrame from '@/shared/assets/svg/deposit-withdraw-success.svg';
import { Link } from '@/shared/components/atoms/Link';
import Button from '@/shared/components/flip-ui-kit/Button';
import { TokenWithChainByAsset } from '@/shared/components/logo/TokenWithChain';
import { type DepositChannel } from '@/shared/hooks/useStateChainAccount';
import useTokenPrice from '@/shared/hooks/useTokenPrice';
import CloseIcon from '@/shared/icons/flip-ui-kit/large/Close';
import WindowIcon from '@/shared/icons/flip-ui-kit/small/Window';
import { formatUsdValue } from '@/shared/utils/numbers';
import type TokenAmount from '@/shared/utils/TokenAmount';
import { DepositInformation } from './DepositInformation';

export const DepositSuccess = ({
  onClose,
  channel,
  amount,
  isWitnessed,
  returnToText,
}: {
  onClose: () => void;
  channel: DepositChannel;
  amount: TokenAmount;
  isWitnessed: boolean;
  returnToText: string;
}) => {
  const { price } = useTokenPrice(channel.asset);
  const usdAmount = price && amount?.mul(price).toNumber();
  const blockExplorerLink = new URL(
    `/channels/${channel.blockNumber}-${channel.asset.chain.chainflipId}-${channel.channelId}`,
    process.env.NEXT_PUBLIC_EXPLORER_URL,
  ).toString();

  return (
    <div className="relative flex w-[487px] flex-col rounded-md border border-cf-gray-4 bg-cf-gray-3 p-6">
      <WithdrawSuccessFrame className="absolute top-0 self-center" />
      <CloseIcon onClick={onClose} className="absolute right-5 top-5 cursor-pointer self-end" />

      <div className="flex flex-col gap-6 pt-[110px]">
        <div className="flex flex-col items-center gap-1 pb-5">
          <div className="font-aeonikMedium text-24 text-white">
            {isWitnessed ? 'Your deposit has arrived' : 'Deposit on its way'}
          </div>
          <div className="flex items-center gap-1 font-aeonikMedium text-16">
            {amount?.toFixed()} <TokenWithChainByAsset asset={channel.asset.chainflipId} />
            {channel.asset.symbol}
            <span className="text-cf-light-2">
              {usdAmount && <div>({formatUsdValue(usdAmount)})</div>}
            </span>
          </div>
        </div>
        <DepositInformation
          channel={channel}
          showMinDepositAmount={false}
          showExplorerLink={false}
        />
        <div className="flex flex-col gap-4">
          <Button size="medium" type="primary-standard" onClick={onClose}>
            {returnToText}
          </Button>
          <Link
            href={blockExplorerLink}
            className="flex w-full items-center justify-center space-x-2 text-14 text-cf-light-3"
            target="_blank"
          >
            <span className="font-aeonikRegular text-14">View on Explorer</span>
            <WindowIcon className="text-cf-light-3" />
          </Link>
        </div>
      </div>
    </div>
  );
};
